export default __webpack_public_path__ + "dfb9d17a239f54ca3ee911843f7dd185.svg";